import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { Add_Channal_Action } from '../../Redux/Actions/ChannalActions';
import { Notify } from '../../Utility/Notify';
import { io } from 'socket.io-client';
import baseurl, { db_url } from '../../Api/BaseUrl';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

const socket = io.connect(db_url);

export const AddChannal = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const navigate = useNavigate();
  const sidebarWidth = useSidebarWidth();

  const [addChannalLoading, setAddChannalLoading] = useState(false);
  const [userlogin, setuserlogin] = useState('');
  const [name, setname] = useState('');
  const [code, setcode] = useState('');
  const [loading, setloading] = useState(true);
  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    if (JSON.parse(localStorage.getItem('user')) != null) {
      setuserlogin(JSON.parse(localStorage.getItem('user')));
    }
  }, []);

  const dispatch = useDispatch();

  /* ── validation ── */
  const validate = () => {
    const errors = {};
    if (!name.trim()) errors.name = 'Channel name is required';
    if (!code.trim()) errors.code = 'Code is required';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const onsubmitadd = async (e) => {
    e.preventDefault();
    if (!validate()) return Notify('error', 'Please fix form errors', 'error');
    
    setAddChannalLoading(true);
    setloading(true);

    await dispatch(
      Add_Channal_Action({
        name,
        code,
      }),
    );
    setloading(false);
    setAddChannalLoading(false);
  };

  const res_add = useSelector((state) => state.AllChannalRoot.channal);

  useEffect(() => {
    if (loading === false) {
      if (res_add && res_add.status === 201) {
        Notify('success', 'Channel Added Successfully', 'success');
        setname('');
        setcode('');
        setFormErrors({});
        setTimeout(() => {
          navigate('/Channel');
        }, 1500);
      } else if (res_add && res_add.status !== 201) {
        Notify('error', res_add.message || 'Failed to add channel', 'error');
      }
      setloading(true);
    }
  }, [loading]);

  const homeRoute = userlogin?.data?.role === 'Admin' || userlogin?.data?.role === 'Marketer'
    ? '/Channel'
    : '/';

  /* ─── shared styles ─── */
  const inputStyle = (hasError) => ({
    width: '100%',
    padding: '13px 16px',
    borderRadius: '10px',
    border: `1.5px solid ${hasError ? '#ef4444' : (isDark ? '#2d3248' : '#e2e8f0')}`,
    backgroundColor: isDark ? '#151827' : '#f8fafc',
    color: isDark ? '#f1f5f9' : '#0f172a',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.2s',
    fontFamily: "'DM Sans',sans-serif",
    boxSizing: 'border-box',
  });

  const labelStyle = {
    display: 'block',
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: isDark ? '#9ca3af' : '#64748b',
    marginBottom: '8px',
  };

  const errorStyle = {
    fontSize: '12px',
    color: '#ef4444',
    margin: '5px 0 0',
  };

  const onFocus = (e) => {
    e.target.style.borderColor = '#2563eb';
    e.target.style.backgroundColor = isDark ? '#1a1f35' : '#ffffff';
    e.target.style.boxShadow = '0 0 0 3px rgba(37,99,235,0.12)';
  };

  const onBlur = (e, hasError) => {
    e.target.style.borderColor = hasError ? '#ef4444' : (isDark ? '#2d3248' : '#e2e8f0');
    e.target.style.backgroundColor = isDark ? '#151827' : '#f8fafc';
    e.target.style.boxShadow = 'none';
  };

  const fieldWrap = { marginBottom: '20px' };

  return (
    <div style={{
      position: 'fixed',
      top: '50px',
      left: sidebarWidth,
      right: 0,
      bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflowY: 'auto',
      background: isDark ? 'linear-gradient(135deg,#0f1117 0%,#1a1d2e 100%)' : '#f0f2f5',
      fontFamily: "'DM Sans','Segoe UI',sans-serif",
      marginTop: '10px',
    }}>

      {/* ── Breadcrumb ── */}
      <div style={{
        padding: '14px 28px',
        backgroundColor: isDark ? '#1a1d2e' : '#f0f2f5',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '13px',
      }}>
        <Link to={homeRoute} style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>
          Home Channel
        </Link>
        <KeyboardDoubleArrowRightIcon sx={{ fontSize: 16, color: isDark ? '#4b5563' : '#d1d5db' }} />
        <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>Add Channel</span>
      </div>

      {/* ── Form ── */}
      <div style={{ padding: '28px 32px 48px' }}>
        <div style={{
          width: '100%',
          maxWidth: '720px',
          backgroundColor: isDark ? '#1e2132' : '#ffffff',
          borderRadius: '20px',
          padding: '36px 40px',
          boxShadow: isDark ? '0 24px 60px rgba(0,0,0,0.5)' : '0 4px 32px rgba(0,0,0,0.08)',
          border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0',
        }}>

          {/* title */}
          <div style={{ marginBottom: '28px' }}>
            <h1 style={{
              fontSize: '22px',
              fontWeight: 700,
              color: isDark ? '#f1f5f9' : '#0d1b3e',
              margin: '0 0 4px',
              letterSpacing: '-0.4px'
            }}>
              Add New Channel
            </h1>
            <p style={{
              fontSize: '13px',
              color: isDark ? '#6b7280' : '#94a3b8',
              margin: 0
            }}>
              Create a new marketing channel in the CRM system
            </p>
          </div>

          {/* ── Channel Name ── */}
          <div style={fieldWrap}>
            <label style={labelStyle}>Channel Name *</label>
            <input
              style={inputStyle(!!formErrors.name)}
              value={name}
              onChange={(e) => {
                setname(e.target.value);
                if (formErrors.name) setFormErrors(p => ({ ...p, name: '' }));
              }}
              type="text"
              placeholder="e.g. Facebook Ads, Google Campaign, Email Marketing"
              onFocus={onFocus}
              onBlur={(e) => onBlur(e, !!formErrors.name)}
              autoFocus
            />
            {formErrors.name && <p style={errorStyle}>{formErrors.name}</p>}
          </div>

          {/* ── Code ── */}
          <div style={fieldWrap}>
            <label style={labelStyle}>Code *</label>
            <input
              style={inputStyle(!!formErrors.code)}
              value={code}
              onChange={(e) => {
                setcode(e.target.value);
                if (formErrors.code) setFormErrors(p => ({ ...p, code: '' }));
              }}
              type="text"
              placeholder="e.g. FB_2026, GOOGLE_01, EMAIL_MARKET"
              onFocus={onFocus}
              onBlur={(e) => onBlur(e, !!formErrors.code)}
            />
            {formErrors.code && <p style={errorStyle}>{formErrors.code}</p>}
            {!formErrors.code && (
              <p style={{
                fontSize: '12px',
                color: isDark ? '#4b5563' : '#94a3b8',
                margin: '5px 0 0'
              }}>
                Unique identifier code for this channel
              </p>
            )}
          </div>

          {/* divider */}
          <div style={{
            height: '1px',
            backgroundColor: isDark ? '#2a2f45' : '#e8eaf0',
            margin: '28px 0'
          }} />

          {/* buttons */}
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={!addChannalLoading ? onsubmitadd : null}
              disabled={addChannalLoading}
              type="button"
              style={{
                flex: 1,
                padding: '14px 24px',
                borderRadius: '10px',
                border: 'none',
                background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
                color: '#fff',
                fontSize: '13px',
                fontWeight: 700,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                cursor: addChannalLoading ? 'not-allowed' : 'pointer',
                opacity: addChannalLoading ? 0.7 : 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                transition: 'all 0.2s',
                boxShadow: '0 4px 16px rgba(29,78,216,0.35)',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => {
                if (!addChannalLoading) {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)';
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)';
              }}
            >
              {addChannalLoading ? (
                <>
                  <CircularProgress size={16} style={{ color: '#fff' }} />
                  <span>Adding...</span>
                </>
              ) : (
                <>
                  <AddIcon sx={{ fontSize: 17 }} />
                  <span>Add Channel</span>
                </>
              )}
            </button>

            <button
              type="button"
              onClick={() => navigate('/Channel')}
              style={{
                padding: '14px 28px',
                borderRadius: '10px',
                border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
                backgroundColor: 'transparent',
                color: isDark ? '#9ca3af' : '#64748b',
                fontSize: '13px',
                fontWeight: 700,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                cursor: 'pointer',
                transition: 'all 0.2s',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = isDark ? '#4b5563' : '#94a3b8';
                e.currentTarget.style.color = isDark ? '#e5e7eb' : '#374151';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = isDark ? '#2d3248' : '#e2e8f0';
                e.currentTarget.style.color = isDark ? '#9ca3af' : '#64748b';
              }}
            >
              Cancel
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};